import { render, staticRenderFns } from "./TipTapChrome.vue?vue&type=template&id=9550b278&"
import script from "./TipTapChrome.vue?vue&type=script&lang=js&"
export * from "./TipTapChrome.vue?vue&type=script&lang=js&"
import style0 from "./TipTapChrome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports